export default class GetWorkTypeByGroupIdAndVersionError extends Error {
  
}